// @mui
import PropTypes from 'prop-types';
import { TableRow, TableCell } from '@mui/material';
//
import EmptyContent from '../EmptyContent';

// ----------------------------------------------------------------------

TableNoData.propTypes = {
  isNotFound: PropTypes.bool,
};

export default function TableNoData({ isNotFound }) {
  return (
    <div className="contents table-no-data">
      {isNotFound ? (
        <TableRow>
          <TableCell colSpan={12}>
            <EmptyContent
              title="در حال حاضر داده ای برای نمایش وجود ندارد"
              sx={{
                '& span.MuiBox-root': { height: 190 },
              }}
            />
          </TableCell>
        </TableRow>
      ) : (
        <TableRow>
          <TableCell colSpan={9} sx={{ p: 0 }} />
        </TableRow>
      )}
    </div>
  );
}
